import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import OrderHistoryProductSelectorState from "@store/Store/Reducers/OrderHistoryProductSelectorState";
import { OrderHistoryProductAutocompleteItemModel, OrderHistoryProductModel } from "@store/Types/ApiModels";
import { Draft } from "immer";

const initialState: OrderHistoryProductSelectorState = {
    isSearching: false,
    variantModalIsOpen: false,
    variantSelection: {},
    variantSelectionCompleted: false,
};

const reducer = {
    "Components/OrderHistoryProductSelector/BeginSearchOrderHistoryProducts": (
        draft: Draft<OrderHistoryProductSelectorState>,
    ) => {
        draft.isSearching = true;
        draft.searchResults = undefined;
    },
    "Components/OrderHistoryProductSelector/CompleteSearchOrderHistoryProducts": (
        draft: Draft<OrderHistoryProductSelectorState>,
        action: { result: OrderHistoryProductAutocompleteItemModel[] | null },
    ) => {
        draft.isSearching = false;
        draft.searchResults = action.result ?? [];
    },
    "Components/OrderHistoryProductSelector/UpdateOptions": (
        draft: Draft<OrderHistoryProductSelectorState>,
        action: { result: OrderHistoryProductModel },
    ) => {
        draft.searchResults = [action.result];
    },
    "Components/OrderHistoryProductSelector/BeginSetOrderHistoryProduct": (
        draft: Draft<OrderHistoryProductSelectorState>,
    ) => {
        delete draft.selectedProduct;
        delete draft.errorType;
    },
    "Components/OrderHistoryProductSelector/CompleteSetOrderHistoryProduct": (
        draft: Draft<OrderHistoryProductSelectorState>,
        action: { selectedProduct?: OrderHistoryProductModel },
    ) => {
        draft.selectedProduct = action.selectedProduct;
    },
    "Components/OrderHistoryProductSelector/SetErrorType": (
        draft: Draft<OrderHistoryProductSelectorState>,
        action: { errorType: string },
    ) => {
        draft.errorType = action.errorType;
    },
    "Components/OrderHistoryProductSelector/CloseVariantModal": (draft: Draft<OrderHistoryProductSelectorState>) => {
        draft.variantModalIsOpen = false;
        draft.variantSelectionCompleted = false;
        draft.variantModalProductId = undefined;
        draft.selectedVariantProductInfo = undefined;
        draft.variantSelection = {};
    },
    "Components/OrderHistoryProductSelector/OpenVariantModal": (
        draft: Draft<OrderHistoryProductSelectorState>,
        action: {
            productId: string;
        },
    ) => {
        draft.variantModalIsOpen = true;
        draft.variantModalProductId = action.productId;
        draft.variantSelection = {};
    },
    "Components/OrderHistoryProductSelector/UpdateVariantSelection": (
        draft: Draft<OrderHistoryProductSelectorState>,
        action: {
            variantSelection: SafeDictionary<string>;
            variantSelectionCompleted: boolean;
            productInfo?: ProductInfo;
        },
    ) => {
        draft.selectedVariantProductInfo = action.productInfo;
        draft.variantSelection = action.variantSelection;
        draft.variantSelectionCompleted = action.variantSelectionCompleted;
    },
    "Components/OrderHistoryProductSelector/Reset": (draft: Draft<OrderHistoryProductSelectorState>) => {
        return { ...initialState };
    },
};

const orderHistoryReducer = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).orderHistoryReducer = orderHistoryReducer;

export type OrderHistoryReducerState = {
    orderHistoryReducer: OrderHistoryProductSelectorState;
} & ApplicationState;

type Reducers = {
    orderHistoryReducer: typeof orderHistoryReducer;
};

export type OrderHistoryProductSelectorReducerActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
